import { render, staticRenderFns } from "./PriceOfFleet.vue?vue&type=template&id=35d335de"
import script from "./PriceOfFleet.vue?vue&type=script&lang=js"
export * from "./PriceOfFleet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports